import React, { useEffect, useRef } from "react";
import styles from "./styles.module.scss";
import { Match } from "../../../../utilities/fp";
import { Empty } from "./shared/Empty";
import { Loading } from "./shared/Loading";
import { Message } from "./shared/Message";

/**
 * @typedef {{
 *   id: number | string;
 *   type: "to-me" | "from-me";
 *   message: string;
 *   date: string;
 *   time: string;
 *   userImageUrl: string;
 *   userName: string;
 * }} Message
 * @param {{
 *   data: Message[];
 *   isLoading?: boolean;
 * }} props
 */
export const Messages = ({ data, isLoading }) => {
  const rootRef = useRef(null);
  useEffect(() => {
    if (rootRef.current && !isLoading) {
      rootRef.current.scrollTop = rootRef.current.scrollHeight;
    }
  }, [isLoading, data?.length]);

  const renderMessages = () => (
    <div className={styles.messages}>
      {data.map((message) => (
        <Message
          key={message.id}
          message={message.message}
          type={message.type}
          date={message.date}
          time={message.time}
          imageUrl={message.userImageUrl}
          name={message.userName}
        />
      ))}
    </div>
  );

  return (
    <div ref={rootRef} className={styles.root} style={{ maxHeight: "450px" }}>
      {Match.of(true)
        .on(isLoading, () => <Loading />)
        .on(data.length === 0, () => <Empty />)
        .or(renderMessages())
        .join()}
    </div>
  );
};
